export default __webpack_public_path__ + "static/media/Woman.aab8f27e.png";